export const environment = {
    production: true,
    // apiUrl: 'https://homolog.artsys.com/backend',
    apiUrl: 'https://homolog.artsys.artcupbrindesoficial.com.br/backend',
    apiUrlSocket: '',
};
